module.exports = __webpack_public_path__ + "static/img/06.ff63499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/06.jpg
// module id = 401
// module chunks = 1